import axiosInstance from '../api/axiosConfig';

// Register with email
export const registerWithEmail = async (firstName, lastName, email, password, phone, dateOfBirth, gender) => {
  const response = await axiosInstance.post('/auth/register', {
    firstName,
    lastName,
    email,
    password,
    phone,
    dateOfBirth,
    gender,
  });
  return response.data;
};

// Verify OTP
export const verifyOTP = async (email, otp) => {
  const response = await axiosInstance.post('/auth/verify-email', {
    email,
    otp,
  });
  return response.data;
};

// Login with email
export const loginWithEmail = async (email, password) => {
  const response = await axiosInstance.post('/auth/login', {
    email,
    password,
  });
  return response.data;
};

// Verify phone OTP
export const verifyPhoneOTP = async (phone, otp) => {
  const response = await axiosInstance.post('/auth/verify-phone', {
    phone,
    otp,
  });
  return response.data;
};

// Send phone verification OTP
export const sendPhoneOTP = async (phone) => {
  const response = await axiosInstance.post('/auth/send-phone-otp', {
    phone,
  });
  return response.data;
};

// Request password reset
export const requestPasswordReset = async (email) => {
  const response = await axiosInstance.post('/auth/request-password-reset', {
    email,
  });
  return response.data;
};

// Reset password with OTP
export const resetPasswordWithOTP = async (email, otp, newPassword) => {
  const response = await axiosInstance.post('/auth/reset-password', {
    email,
    otp,
    newPassword,
  });
  return response.data;
};

// Refresh token
export const refreshToken = async () => {
  const response = await axiosInstance.post('/auth/refresh');
  return response.data;
};

// Complete user profile
export const completeProfile = async (dateOfBirth, gender) => {
  const response = await axiosInstance.post('/auth/complete-profile', {
    dateOfBirth,
    gender,
  });
  return response.data;
};

// Get current user
export const getCurrentUser = async () => {
  const response = await axiosInstance.get('/auth/me');
  return response.data;
};
